var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\n	<div class="item host-item ';
 if(data.index%2){
__p+='odd';
}
__p+='" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		<div class="main">\n			<div class="rank">'+
((__t=(data.index))==null?'':__t)+
'</div>\n			<div class="user">\n	            <div class="avatar">\n	            	<span class="ui-img ui-circle" node-id="profile" data-uid="'+
((__t=(data.uid))==null?'':__t)+
'">\n	            		<img node-id="img" data-src="'+
((__t=(data.avatar))==null?'':__t)+
'" data-size="42"/>\n	            	</span>\n	            	';
if(data.status ==1){
__p+='\n		              <div class="show" node-id="liveRoom"  data-uid="'+
((__t=(data.uid))==null?'':__t)+
'" data-rid="'+
((__t=(data.roomid))==null?'':__t)+
'">\n		              	<span></span>\n		              	<span></span>\n		              </div>\n		         	';
}
__p+='\n	            </div>\n	            <div class="info">\n	                <dl>\n	                  	<dd class="nickname">\n	                  		<span>'+
((__t=(data.username))==null?'':__t)+
'</span>\n	                  		<div class="ui-gender" data-gender="'+
((__t=(data.gender))==null?'':__t)+
'"></div>\n	                  		<div class="ui-grade" node-id="grade" data-grade="'+
((__t=(data.grade))==null?'':__t)+
'"></div>\n	                  	</dd>\n	                  	';
if(data.upliveCode){
__p+='\n	                  	<dd class="uplive-code">\n	                    	'+
((__t=(UpAct.lang.template('Up号:{code}',{code:data.upliveCode})))==null?'':__t)+
'\n	                  	</dd>\n	                  	';
 }
__p+='\n	                  	<dd class="giftcount">\n	                    	'+
((__t=(UpAct.lang.template('总u币数:{count}', {count: UpAct.NumberUtil.separate(data.giftPoint, ',')}) ))==null?'':__t)+
'\n	                  	</dd>\n	                </dl>\n	            </div>\n	        </div>\n	        \n	    </div>\n	    \n	    <div class="extend">\n	    	\n	    	<div class="gift" node-id="xxx">\n	    		';

					_.each(UpAct.actData[acid].gift,function(item,index){
				
__p+='\n					<div class="gift-info" >\n		    			<span class="gift-pic"><img src="'+
((__t=(item.image))==null?'':__t)+
'" /></span>\n		    			<span class="gift-name">x'+
((__t=(data.giftInfo[index].giftCount ))==null?'':__t)+
'</span>\n		    		</div>\n				\n				';
	
				})
		    	
__p+='\n	    		\n	    	</div>\n	    	\n	    </div>\n	    \n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/component/hostlist/item.tmpl
// module id = 50
// module chunks = 0 1